var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 19.25c.828 0 1.5.616 1.5 1.375 0 .705-.58 1.286-1.325 1.366L28.5 22h-27C.672 22 0 21.384 0 20.625c0-.705.58-1.286 1.325-1.366l.175-.009h27Zm0-9.625c.828 0 1.5.616 1.5 1.375 0 .705-.58 1.286-1.325 1.366l-.175.009h-27C.672 12.375 0 11.759 0 11c0-.705.58-1.286 1.325-1.366l.175-.009h27ZM28.5 0c.828 0 1.5.616 1.5 1.375 0 .705-.58 1.286-1.325 1.366l-.175.009h-27C.672 2.75 0 2.134 0 1.375 0 .67.58.089 1.325.009L1.5 0h27Z",
    fill: "#5C7AFF"
  })));
};

export default SvgHamburger;